import { useHandleCsvDownload } from "./use-handle-csv-download";

import type * as _Model from "../../../../../model";

type Props = {
	viewData: _Model.Type.ViewData;
};

export const useInitialized = ({ viewData }: Props) => {
	const { onCsvDownload } = useHandleCsvDownload({ viewData });

	return {
		onCsvDownload,
	};
};
